import React from 'react'
import config from '../config.json'
import checkForAttributeMapping from '../functions/checkForAttributeMapping'
import sortAlphabetical from '../functions/sortAlphabetical'
import AttributeIcon from '../General/AttributIcon'
import AttributeTooltip from '../General/AttributeTooltip'
import { useState } from 'react'

const ItemAttributes = ({attributes, attributeStyling, hiddenAttributes, performanceAttribute=true, translation, isMobile, canBeColored=false}) => {
    if(!attributes) {
        return ''
    }
    const [mouseOver, setMouseOver] = useState(false)
    const coloredAttributes = attributeStyling === 'colored_language_attributes' ? ' colored-icon' : ''
    const attributesIdArray = _.pluck(attributes, 'id')

    const technicalAttributesIdsOnly = _.filter(attributesIdArray, (attr) => {
        return _.contains(config.attributesWithIcons, attr.trim())
    })

    let attributesSorted = sortAlphabetical(attributes)

    return attributesSorted.map((attribute, index) => {
        const { id, name } = attribute
        const attributeIdWithoutSpace = id.trim();
        const isTooltipped = performanceAttribute && _.contains(_.keys(config.tooltippedAttributes), attributeIdWithoutSpace.toLowerCase())
        const logoClass = performanceAttribute ? _.contains(config.attributesWithIcons, id) ? 'attribute-logo' : 'attribute-name' : 'attribute-logo'

        if(attributeIdWithoutSpace === 'digital' || _.contains(hiddenAttributes, attributeIdWithoutSpace) || (attributeIdWithoutSpace.search("pricelevel") !== -1 && !_.contains(config.acceptedPricelevels, id))) {
            return ''
        }
        
        if(_.contains(config.attributesWithIcons, attributeIdWithoutSpace)) {
            let showAttributes = true
            if(attributeIdWithoutSpace === "2d" || attributeIdWithoutSpace === "1087") {
                if(technicalAttributesIdsOnly.length === 1 && (technicalAttributesIdsOnly[0] === '2d' || technicalAttributesIdsOnly[0] === '1087')) {
                    showAttributes = false
                } else if(technicalAttributesIdsOnly.length > 1 && (_.contains(technicalAttributesIdsOnly, "2d") && !_.contains(technicalAttributesIdsOnly, "3d"))) {
                    showAttributes = false
                }
            }

            if(canBeColored) {
                return (
                    showAttributes && <div key={index} className={"attribute" + coloredAttributes + ' ' + attributeIdWithoutSpace} onMouseOver={() => {!isMobile && setMouseOver(true)}} onMouseOut={() => {!isMobile && setMouseOver(false)}}>
                        <span className={logoClass + ' ' + attributeIdWithoutSpace} data-attribute={attributeIdWithoutSpace}>
                            <AttributeIcon attributeId={attributeIdWithoutSpace}/>
                            <span className="pm-screen-reader-text">{name}</span>
                        </span>
                        {isTooltipped && isMobile && <div className="mobile-hint" onClick={() => {setMouseOver(!mouseOver)}}> ? </div>}
                        {isTooltipped && <AttributeTooltip mouseOver={mouseOver} onClick={() => {setMouseOver(false)}} isMobile={isMobile} translation={translation} attributeId={attributeIdWithoutSpace.toLowerCase()}/>}
                    </div>
                )
            } else {
                return (
                    showAttributes && <div key={index} className={"attribute" + ' ' + attributeIdWithoutSpace} onMouseOver={() => {!isMobile && setMouseOver(true)}} onMouseOut={() => {!isMobile && setMouseOver(false)}}>
                        <span className={logoClass + " attribute-logo-" + attributeIdWithoutSpace} data-attribute={attributeIdWithoutSpace}>
                            <AttributeIcon attributeId={attributeIdWithoutSpace}/>
                            <span className="pm-screen-reader-text">{name}</span>
                        </span>
                        {isTooltipped && isMobile && <div onClick={() => {setMouseOver(!mouseOver)}}> ? </div>}
                        {isTooltipped && <AttributeTooltip mouseOver={mouseOver} onClick={() => {setMouseOver(false)}} isMobile={isMobile} translation={translation} attributeId={attributeIdWithoutSpace.toLowerCase()}/>}
                    </div>
                )
            }
        } else {
            const attributesName = checkForAttributeMapping(name, translation)

            return performanceAttribute ? (
                <span className={id + ' ' + logoClass} data-attribute={id} key={index}>
                     <span className={'text-medium'}>{attributesName}</span>
                 </span>
            ) : (
                <div key={index} className={"attribute item-post-information attribute-text accent-color-background other-attributes " + attributesName}>{attributesName}</div>
            )
        }
    })
}

export default ItemAttributes